import React, { useState } from "react";
import { ChevronDown } from "lucide-react";
import { useCbomContext } from "../context/CbomContext";
import ImportModal from "./ImportModal";
import { addSensorAgent } from "../services/apiServices";
import { useProjectContext } from "context/ProjectContext";
import { TailSpin } from "react-loader-spinner";

const UploadAgent: React.FC = () => {
  const { state } = useProjectContext();
  const {
    showAgentUpload,
    setShowAgentUpload,
    setShowAgentUploadForm,
    isAgentUploaded,
  } = useCbomContext();
  const [isLoading, setIsLoading] = useState<boolean>(false);
  const [formData, setFormData] = useState({
    sensor_agent_name: "",
    sensor_agent_type: "Host",
    sensor_agent_os_type: "Linux",
    sensor_agent_cpu_type: "",
    sensor_agent_state: "Inactive",
    sensor_agent_version: "1.0.0",
  });

  const handleChange = (
    e: React.ChangeEvent<HTMLInputElement | HTMLSelectElement>
  ) => {
    const { name, value } = e.target;
    setFormData((prev) => ({ ...prev, [name]: value }));
  };

  const handleSubmit = async (e: React.FormEvent) => {
    e.preventDefault();
    // console.log(formData);
    setIsLoading(true);
    try {
      if (state.currentProjectID) {
        await addSensorAgent(formData, state.currentProjectID);
        setShowAgentUploadForm(false);
      }
    } catch (err) {
      console.error(err);
    } finally {
      setIsLoading(false);
    }
  };
  return (
    <div className="flex flex-col w-full overflow-auto">
      <div className="w-full bg-custom-blue8 rounded-[10px]">
        <form onSubmit={handleSubmit}>
          <div className="bg-custom-lightbg rounded-[10px] mx-5">
            {/* Row 1 */}
            <div className="flex items-center">
              <div className="p-[10px] space-y-[10px] w-1/2">
                <label className="font-bold text-sm text-custom-bluenew">
                  Sensor Agent Name<span className="text-red-500">*</span>
                </label>
                <input
                  name="sensor_agent_name"
                  type="text"
                  required
                  onChange={handleChange}
                  value={formData.sensor_agent_name}
                  className="w-full p-3 rounded-[4px] bg-white text-custom-bluenew focus:outline-none focus:ring-2 focus:ring-custom-bluenew"
                />
              </div>
              <div className="p-[10px] space-y-[10px] w-1/2">
                <label className="font-bold text-sm text-custom-bluenew">
                  Sensor Agent Type<span className="text-red-500">*</span>
                </label>
                <div className="relative flex items-center">
                  <select
                    name="sensor_agent_type"
                    required
                    value={formData.sensor_agent_type}
                    onChange={handleChange}
                    className="w-full p-3 rounded-[4px] bg-white text-custom-bluenew focus:outline-none focus:ring-2 focus:ring-custom-bluenew"
                  >
                    <option value="Host">Host</option>
                    <option value="Agent">Agent</option>
                  </select>
                  <ChevronDown className="absolute right-[3px] bg-white text-custom-bluenew" />
                </div>
              </div>
            </div>

            {/* Row 2 */}
            <div className="flex items-center">
              <div className="p-[10px] space-y-[10px] w-1/2">
                <label className="font-bold text-sm text-custom-bluenew">
                  Sensor Agent OS type<span className="text-red-500">*</span>
                </label>
                <div className="relative flex items-center">
                  <select
                    name="sensor_agent_os_type"
                    required
                    value={formData.sensor_agent_os_type}
                    onChange={handleChange}
                    className="w-full p-3 rounded-[4px] bg-white text-custom-bluenew focus:outline-none focus:ring-2 focus:ring-custom-bluenew"
                  >
                    <option value="Linux">Linux</option>
                    <option value="Windows">Windows</option>
                  </select>
                  <ChevronDown className="absolute right-[3px] bg-white text-custom-bluenew" />
                </div>
              </div>
              <div className="p-[10px] space-y-[10px] w-1/2">
                <label className="font-bold text-sm text-custom-bluenew">
                  Sensor Agent CPU type<span className="text-red-500">*</span>
                </label>
                <div className="relative flex items-center">
                  <select
                    name="sensor_agent_cpu_type"
                    required
                    value={formData.sensor_agent_cpu_type}
                    onChange={handleChange}
                    className="w-full p-3 rounded-[4px] bg-white text-custom-bluenew focus:outline-none focus:ring-2 focus:ring-custom-bluenew"
                  >
                    <option value="">Select CPU Type</option>
                    <option value="X86">X86</option>
                    <option value="ARM">ARM</option>
                    <option value="PowerPC">PowerPC</option>
                  </select>
                  <ChevronDown className="absolute right-[3px] bg-white text-custom-bluenew" />
                </div>
              </div>
            </div>

            {/* Row 3 */}
            <div className="flex items-center">
              <div className="p-[10px] space-y-[10px] w-1/2">
                <label className="font-bold text-sm text-custom-bluenew">
                  Sensor Agent state<span className="text-red-500">*</span>
                </label>
                {/* <input
                  type="text"
                  disabled
                  value="Inactive"
                  className="w-full p-3 rounded-[4px] bg-white text-custom-bluenew"
                /> */}
                <div className="relative flex items-center">
                  <select
                    name="sensor_agent_state"
                    required
                    value={formData.sensor_agent_state}
                    onChange={handleChange}
                    className="w-full p-3 rounded-[4px] bg-white text-custom-bluenew focus:outline-none focus:ring-2 focus:ring-custom-bluenew"
                  >
                    <option value="Active">Active</option>
                    <option value="Inactive">Inactive</option>
                  </select>
                  <ChevronDown className="absolute right-[3px] bg-white text-custom-bluenew" />
                </div>
              </div>
              <div className="p-[10px] space-y-[10px] w-1/2">
                <label className="font-bold text-sm text-custom-bluenew">
                  Sensor Agent Version
                </label>
                <input
                  name="sensor_agent_version"
                  type="text"
                  value={formData.sensor_agent_version}
                  onChange={handleChange}
                  placeholder="X86"
                  className="w-full p-3 rounded-[4px] bg-white text-custom-bluenew focus:outline-none focus:ring-2 focus:ring-custom-bluenew"
                />
              </div>
            </div>
          </div>

          {/* Buttons */}
          <div className="flex items-center justify-center gap-20 pt-5 pb-8">
            <button
              type="button"
              className="px-6 h-[40px] bg-custom-blue5 text-white rounded-lg"
              onClick={() => setShowAgentUpload(true)}
            >
              Upload
            </button>
            <button
              type="submit"
              disabled={!isAgentUploaded || isLoading}
              className={`flex items-center justify-center px-6 h-[40px] rounded-lg 
              ${
                isAgentUploaded
                  ? "bg-custom-blue7 text-white"
                  : "bg-gray-400 cursor-not-allowed text-white"
              }`}
            >
              {isLoading ? (
                <>
                  <TailSpin height={17} width={17} color="#fff" />
                  <span className="ml-2">Please wait...</span>
                </>
              ) : (
                "Activate"
              )}
            </button>
          </div>
          {showAgentUpload && <ImportModal />}
        </form>
      </div>
    </div>
  );
};

export default UploadAgent;
